import { createStyles } from 'antd-style'

/**
 * Only the dark pane's own content. The two-pane grid, the brand row, the
 * centring and the legal footer live in `PublicSplitShell`, which workspace
 * creation wears too — the paddings drifted while each surface kept a copy.
 */
export const useStyles = createStyles(({ token }) => ({
  /** Value-prop content on the dark pane. */
  heroContent: {
    maxWidth: 440
  },

  heroTitle: {
    // h2 (so the form's AuthHeader stays the sole h1) kept at display size.
    fontSize: '28px !important',
    lineHeight: '1.2 !important',
    color: `${token.colorWhite} !important`,
    marginBottom: '0 !important'
  },

  heroSubtitle: {
    color: 'rgba(255,255,255,0.72)',
    fontSize: token.fontSizeLG,
    lineHeight: 1.6
  },

  heroFeatureIcon: {
    flexShrink: 0,
    width: 32,
    height: 32,
    borderRadius: token.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255,255,255,0.1)',
    color: token.colorWhite
  },

  heroFeatureText: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: token.fontSize
  }
}))
